import { Row,Col} from 'antd';
import courseScheduleImg from '../../img/ourCourse/2026schedule.png'
import courseScheduleImgPh from "../../img/ourCourse/2026scheduleph.png";
export const CourseSchedule=()=>{
    return (
      <Row>
        <Col xs={0} sm={0} md={0} lg={24} xl={24} xxl={24}>
          <div className="courseSchedule">
            <img
              src={courseScheduleImg}
              alt="courseSchedule"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </Col>
        <Col sm={24} xs={24} md={24} lg={0} xl={0}>
          <div className="courseSchedule">
            <img
              src={courseScheduleImgPh}
              alt="courseSchedule"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </Col>
      </Row>
    );
}